import _asyncToGenerator from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Group from 'src/store/models/Group';
import User from 'src/store/models/User';
import { forEach } from 'lodash';
export default {
  props: {
    tickStrategy: {
      type: String,
      default: 'strict'
    },
    tickedObjects: Array,
    showAddHeader: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    project: Object
  },
  data: function data() {
    return {
      nodes: [],
      ticked: [],
      loading: true
    };
  },
  watch: {
    project: {
      deep: true,
      handler: 'initNodes'
    },
    groups: 'initNodes',
    usersWithoutGroups: 'initNodes',
    nodes: {
      deep: true,
      handler: 'updateSelection'
    },
    ticked: {
      deep: true,
      handler: 'updateSelection'
    }
  },
  computed: {
    groups: function groups() {
      return Group.query().with('users.avatar').orderBy('name').get();
    },
    usersWithoutGroups: function usersWithoutGroups() {
      return User.query().where('enabled', 1).with('avatar').hasNot('groups').get();
    },
    expandAll: function expandAll() {
      return User.query().count() < 10;
    }
  },
  methods: {
    updateSelection: function updateSelection() {
      var _this = this;

      if (!this.loading) {
        var objects = [];
        this.ticked.forEach(function (nodeId) {
          var nodeParts = nodeId.split('_');

          _this.nodes.forEach(function (node) {
            if (node.id === nodeId) {
              objects.push({
                type: nodeParts[0],
                id: nodeParts[1]
              });
            }

            node.children.forEach(function (node) {
              if (node.id === nodeId) {
                objects.push({
                  type: nodeParts[0],
                  id: nodeParts[1],
                  is_pm: node.is_pm,
                  budget_minutes: node.budget_minutes,
                  hourly_rate: node.hourly_rate
                });
              }
            });
          });
        });
        this.$emit('update:tickedObjects', objects);
      }
    },
    isTicked: function isTicked(node) {
      return this.ticked.filter(function (tickedNode) {
        return tickedNode === node.id;
      }).length > 0;
    },
    initNodes: function initNodes() {
      var _this2 = this;

      var nodes = []; // Add a node for each group and its children (users)

      forEach(this.groups, function (group) {
        var node = {
          header: 'group',
          id: 'group_' + group.group_id,
          group_id: group.group_id,
          label: group.name,
          // lazy: true,
          disabled: _this2.project ? _this2.project.is_public : false,
          users_count: group.users_count,
          users_archived_count: group.users_archived_count,
          projects_count: group.projects_count,
          color: group.color,
          children: []
        };
        forEach(group.users, function (user) {
          var projectUser = _this2.project ? _this2.project.users.find(function (projectUser) {
            return projectUser.user_id === user.user_id;
          }) : null;
          node.children.push({
            header: 'user',
            id: 'user_' + user.user_id,
            user_id: user.user_id,
            group_id: group.group_id,
            label: user.name,
            disabled: _this2.project ? _this2.project.is_public : false,
            enabled: user.enabled,
            avatar_url: user.avatar ? user.avatar.avatar_url : null,
            is_pm: projectUser ? projectUser.pivot.is_pm : 0,
            budget_minutes: projectUser ? projectUser.pivot.budget_minutes : null,
            budget_time: projectUser ? _this2.$options.filters.formatTimeHtmlReports(projectUser.pivot.budget_minutes) : null,
            hourly_rate: projectUser ? projectUser.pivot.hourly_rate : null
          });
        });
        node.children.sort(function (a, b) {
          return a.label.localeCompare(b.label);
        });
        nodes.push(node);
      }); // Add users without groups node

      if (this.usersWithoutGroups.length) {
        var usersWithoutGroupsNode = {
          header: 'group',
          id: 'group_-1',
          group_id: -1,
          disabled: this.project ? this.project.is_public : false,
          label: this.$t('components.groups.users_without_group'),
          users_count: this.usersWithoutGroups.length,
          children: []
        };
        this.usersWithoutGroups.forEach(function (user) {
          var projectUser = _this2.project ? _this2.project.users.find(function (projectUser) {
            return projectUser.user_id === user.user_id;
          }) : null;
          usersWithoutGroupsNode.children.push({
            header: 'user',
            id: 'user_' + user.user_id,
            user_id: user.user_id,
            group_id: -1,
            label: user.name,
            avatar_url: user.avatar ? user.avatar.avatar_url : null,
            is_pm: 0,
            disabled: _this2.project ? _this2.project.is_public : false,
            budget_minutes: projectUser ? projectUser.pivot.budget_minutes : null,
            budget_time: projectUser ? _this2.$options.filters.formatTimeHtmlReports(projectUser.pivot.budget_minutes) : null,
            hourly_rate: null
          });
        });
        nodes.push(usersWithoutGroupsNode);
      }

      this.nodes = nodes;
    },
    setBudgetMinutes: function setBudgetMinutes(node) {
      var components = node.budget_time.split(':');

      if (components[0] && isFinite(parseInt(components[0]))) {
        node.budget_minutes = parseInt(components[0]) * 60;
      } else {
        node.budget_minutes = 0;
      }

      if (components[1] && isFinite(parseInt(components[1]))) {
        node.budget_minutes += parseInt(components[1]);
      }
    },
    loadGroups: function loadGroups() {
      var _this3 = this;

      this.loading = true;
      return Group.api().get('/groups').finally(function (response) {
        _this3.loading = false;
      });
    },
    loadUsers: function loadUsers() {
      var _this4 = this;

      this.loading = true;
      return User.api().get('/users', {
        params: {
          account_id: this.me.account_id
        }
      }).finally(function (response) {
        _this4.loading = false;
      });
    },
    selectedAllUsers: function selectedAllUsers() {
      this.ticked = User.all().map(function (user) {
        return 'user_' + user.user_id;
      });
    },
    selectedAllGroups: function selectedAllGroups() {
      var newTicks = [];
      this.nodes.forEach(function (node) {
        newTicks.push(node.id);

        if (node.children && node.children.length > 0) {
          node.children.forEach(function (node) {
            newTicks.push(node.id);
          });
        }
      });
      this.ticked = newTicks;
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this5.loadGroups();

            case 2:
              _context.next = 4;
              return _this5.loadUsers();

            case 4:
              if (_this5.tickedObjects) {
                _this5.tickedObjects.forEach(function (object) {
                  _this5.ticked.push(object.type + '_' + object.id);
                });
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};